import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  customerUUID: "",
  applicationUUID: "",
  currentTimelineStep: 1,
  previousWindowRoute: "",
};

const userSlice = createSlice({
  name: "userDetails",
  initialState: { ...initialState },
  reducers: {
    setUserDetails: (state, action) => {
      const {
        firstName,
        lastName,
        userEmail,
        userPhone,
        customerUUID,
        applicationUUID,
      } = action.payload || {};

      state.firstName = firstName || state.firstName;
      state.lastName = lastName || state.lastName;
      state.email = userEmail || state.email;
      state.phone = userPhone || state.phone;
      state.customerUUID = customerUUID || state.customerUUID;
      state.applicationUUID = applicationUUID || state.applicationUUID;
    },

    setUserTimelineStep: (state, action) => {
      const currentTimelineStep = action.payload;
      state.currentTimelineStep =
        currentTimelineStep || state.currentTimelineStep;
    },

    setPreviousWindowRoute: (state, action) => {
      const previousWindowRoute = action.payload;

      state.previousWindowRoute =
        previousWindowRoute || state.previousWindowRoute;
    },

    resetUserDetails: (state) => {
      return { ...initialState };
    },
  },
});

export const {
  setUserDetails,
  resetUserDetails,
  setUserTimelineStep,
  setPreviousWindowRoute,
} = userSlice.actions;
export default userSlice.reducer;
